module.exports = __webpack_public_path__ + "static/img/img-v3-dialog.d2b1e17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-v3-dialog.png
// module id = /x9J
// module chunks = 1